import { topicWall } from "@/mocks/heiliao";

export default function TopicWall() {
  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="mb-6 flex flex-col justify-between gap-2 sm:flex-row sm:items-end">
          <div>
            <div className="mb-1 flex items-center gap-2 text-xs font-bold tracking-widest text-accent-700">
              <i className="ri-hashtag text-sm"></i>话题墙
            </div>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              现在都在吵什么
            </h2>
          </div>
          <p className="max-w-sm text-sm text-foreground-500">
            按被讨论的密度聚成的标签。点进去能看这一题材下已收齐的证据链，而不是只有情绪。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {topicWall.map((t) => (
            <a
              key={t.tag}
              href="#latest"
              className="group flex flex-row items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-lg text-secondary-900">
                <i className="ri-fire-fill"></i>
              </span>
              <span className="min-w-0">
                <span className="block truncate font-bold text-foreground-950 group-hover:text-primary-700">
                  {t.tag}
                </span>
                <span className="mt-0.5 block truncate text-xs text-foreground-500">{t.desc}</span>
              </span>
              <span className="ml-auto whitespace-nowrap text-xs font-bold text-primary-600">{t.count}+</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}